import { render, staticRenderFns } from "./HomeDebtorsCard.vue?vue&type=template&id=40c5c1dc&scoped=true&"
import script from "./HomeDebtorsCard.vue?vue&type=script&lang=js&"
export * from "./HomeDebtorsCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeDebtorsCard.vue?vue&type=style&index=0&id=40c5c1dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c5c1dc",
  null
  
)

export default component.exports